/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Components.Envelopes";
        /**
         * Component for display of envelopes for the user.
         */
        class ComponentEnvelopes extends Widgets.ComponentBaseClass {
            constructor(core, container, parent, config) {
                super(core, container, parent);
                this._config = null;
                this._componentReady = false;
                this._displayPending = false;
                this._searchRunning = false;
                this._pendingFilterText = null;
                // Access
                this.EnvelopeSelectedCallBack = null;
                this.EnvelopeContentCallBack = null;
                this.EnvelopeAddedCallBack = null;
                this.DocumentAddedCallBack = null;
                // UI Components
                this._loader = null;
                this._noRecords = null;
                this._holder = null;
                this._dataList = null;
                this._deleteButton = null;
                this._removeDocButton = null;
                this._envelopes = null;
                this._newEnvelopeId = null;
                this._selectNewEnvelopes = true;
                this._currentEnvelope = null;
                this._currentContentIds = [];
                this._currentDocId = null;
                this._selectOnlyMode = false;
                this._showDelete = true;
                this._showRemoveDoc = true;
                // Add modal support
                this._currentModalSession = null;
                this._addModalLoader = null;
                this._addModalInput = null;
                this._addModalOK = null;
                this._addModalNameExists = null;
                this._storeHtml = (htmlData) => {
                    this._log.info("ComponentEnvelopes._storeHtml()");
                    ComponentEnvelopes.Html = htmlData;
                    if (ComponentEnvelopes.ModalHtml != null) {
                        this._readyToPresent = true;
                        if (this._waitingToPresent)
                            this._present();
                    }
                };
                this._storeModalHtml = (htmlData) => {
                    this._log.info("ComponentEnvelopes._storeModalHtml()");
                    ComponentEnvelopes.ModalHtml = htmlData;
                    if (ComponentEnvelopes.Html != null) {
                        this._readyToPresent = true;
                        if (this._waitingToPresent)
                            this._present();
                    }
                };
                this.doSearch = () => {
                    this._log.info("ComponentEnvelopes.doSearch()");
                    if (!this._componentReady) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("not ready, pending search");
                        }
                        this._displayPending = true;
                        return;
                    }
                    this._searchRunning = true;
                    this._core.Functions.showElement(this._loader);
                    this._core.Loader.genericServiceCall('/User.svc/rest/GetEnvelopes', this._displayResult, this._errorCallback, this._failCallback);
                };
                this.filterEnvelopes = (filterText) => {
                    this._log.info("ComponentEnvelopes.filterEnvelopes()");
                    if (!this._componentReady || this._searchRunning) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("not ready or running search, pending filter");
                        }
                        this._pendingFilterText = filterText;
                        return;
                    }
                    this._pendingFilterText = null;
                    this._dataList.filterItems(filterText);
                };
                this._displayResult = (response) => {
                    this._log.info("ComponentEnvelopes._displayResult()");
                    this._core.Functions.hideElement(this._loader);
                    this._currentContentIds = [];
                    this._core.Functions.hideElement(this._deleteButton);
                    this.documentSelected(-1);
                    this._dataList.clearList();
                    let newEnvelopeAvailable = false;
                    if (response.hasOwnProperty('Envelopes') && response.Envelopes.length > 0) {
                        this._envelopes = response.Envelopes;
                        let envelopesLength = response.Envelopes.length;
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("got envelopes: " + envelopesLength);
                        }
                        this._core.Functions.hideElement(this._noRecords);
                        this._core.Functions.showElement(this._holder);
                        let listData = {
                            Items: []
                        };
                        for (let i = 0; i < envelopesLength; i++) {
                            let env = response.Envelopes[i];
                            let itemData = {
                                Id: env.Id.toString(10),
                                DisplayName: env.Name
                            };
                            listData.Items.push(itemData);
                            if (this._newEnvelopeId == env.Id)
                                newEnvelopeAvailable = true;
                        }
                        this._dataList.displayData(listData);
                    }
                    else {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("got NO envelopes");
                        }
                        this._core.Functions.hideElement(this._holder);
                        this._core.Functions.showElement(this._noRecords);
                        this._envelopes = [];
                    }
                    this._searchRunning = false;
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("looking at pending filter: " + this._pendingFilterText);
                    }
                    if (this._pendingFilterText != null)
                        this.filterEnvelopes(this._pendingFilterText);
                    if (newEnvelopeAvailable && this._selectNewEnvelopes)
                        this._envelopeClicked(this._newEnvelopeId.toString(10));
                    this._newEnvelopeId = null;
                };
                this._envelopeClicked = (envelopeId) => {
                    this._log.info("ComponentEnvelopes._envelopeClicked()");
                    let envId = Number(envelopeId);
                    let env = this._envelopes.find(e => e.Id == envId);
                    this._currentEnvelope = env;
                    this._dataList.clearItemSelection();
                    this._dataList.selectItem(envelopeId);
                    if (this._showDelete)
                        this._core.Functions.showElement(this._deleteButton);
                    if (this.EnvelopeSelectedCallBack)
                        this.EnvelopeSelectedCallBack(env);
                };
                this.getEnvelopeContent = (envId) => {
                    this._log.info("ComponentEnvelopes.getEnvelopeContent()");
                    // Note this overrides select-only mode as it has to be explicitly called
                    this._core.Loader.genericServiceCall(`/User.svc/rest/GetEnvelopeDocuments/${envId}`, this._docListReceived.bind(this, envId), this._errorCallback, this._failCallback);
                };
                this._docListReceived = (envId, response) => {
                    this._log.info("ComponentEnvelopes._docListReceived()");
                    this._currentContentIds = [];
                    if (response.hasOwnProperty('Envelopes') && (response.Envelopes != null)) {
                        let env = response.Envelopes[0];
                        // Don't return something which may cause a crash
                        if (!env.hasOwnProperty('Documents') || (env.Documents == null))
                            env.Documents = [];
                        env.Documents.forEach(doc => {
                            this._currentContentIds.push(doc.ItemNum);
                        });
                        if (this.EnvelopeContentCallBack)
                            this.EnvelopeContentCallBack(env);
                    }
                };
                this.deleteEnvelope = (envId) => {
                    this._log.info("ComponentEnvelopes.deleteEnvelope()");
                    this._core.Loader.genericServiceCall(`/User.svc/rest/DeleteEnvelope/${envId}`, this._envelopeDeleted, this._errorCallback, this._failCallback);
                };
                this._envelopeDeleted = (response) => {
                    this._log.info("ComponentEnvelopes._envelopeDeleted()");
                    this._core.Functions.showElement(this._loader);
                    this._core.Loader.genericServiceCall('/User.svc/rest/GetEnvelopes', this._displayResult, this._errorCallback, this._failCallback);
                };
                this.addEnvelope = (event, useSecondModal = false) => {
                    this._log.info("ComponentEnvelopes.addEnvelope()");
                    // Set up modal
                    let modalSession = 'add-envelope-modal-' + performance.now();
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("created modal session: " + modalSession);
                    }
                    let modalType = WPTNamespace.ModalType.FIRST;
                    if (useSecondModal) {
                        modalType = WPTNamespace.ModalType.SECOND;
                    }
                    let modal = this._core.requestModal(modalType, modalSession);
                    if (modal !== null && modal !== undefined) {
                        this._currentModalSession = modalSession;
                        modal.DIV.innerHTML = ComponentEnvelopes.ModalHtml;
                        this._addModalLoader = modal.DIV.querySelector('.wpt-hourglass');
                        this._addModalInput = modal.DIV.querySelector('#envelopesAddTextbox');
                        this._addModalOK = modal.DIV.querySelector('#envelopesAddOK');
                        this._addModalNameExists = modal.DIV.querySelector('#envelopesNameExistsBanner');
                        let closeIcon = modal.DIV.querySelector('#closeIcon');
                        this._core.Helper.prepareHourglassIcon(this._addModalLoader);
                        this._core.Helper.setElementTranslation(modal.DIV.querySelector('#envelopesAddDialogHeading'), 'STR_WPT_ADD_ENVELOPE');
                        this._core.Helper.setElementTranslation(modal.DIV.querySelector('#envelopesAddProcessing'), 'STR_WPT_PROCESSING');
                        let nameTranslation = this._core.Locale.getTranslation('STR_WPT_NAME');
                        modal.DIV.querySelector('#envelopesAddLabel').innerHTML = nameTranslation;
                        this._addModalInput.setAttribute('placeholder', nameTranslation);
                        let cancelTranslation = this._core.Locale.getTranslation('STR_WPT_CANCEL');
                        closeIcon.setAttribute('aria-label', cancelTranslation);
                        closeIcon.setAttribute('title', cancelTranslation);
                        modal.DIV.querySelector('#envelopesAddCancelLabel').innerHTML = cancelTranslation;
                        this._core.Helper.setElementTranslation(this._addModalOK.querySelector('#envelopesAddOKLabel'), 'STR_WPT_LABEL_OK');
                        this._core.Helper.setElementTranslation(modal.DIV.querySelector('#envelopesNameExistsLabel'), 'STR_WPT_ENVELOPE_EXISTS');
                        this._addModalOK.addEventListener('click', this._addOKClicked);
                        this._addModalInput.addEventListener('input', this._enableDisableAddOK);
                        this._addModalInput.addEventListener('keyup', this._addInputEnter);
                        this._core.showModal(modalSession);
                    }
                    else {
                        console.error("unable to show add envelope modal, modal placeholder is already used");
                    }
                };
                this._addOKClicked = (event) => {
                    this._log.info("ComponentEnvelopes._addOKClicked()");
                    // Don't allow duplicate names
                    if (this._envelopes) {
                        let existingEnvelope = this._envelopes.find(env => env.Name == this._addModalInput.value);
                        if (existingEnvelope) {
                            this._core.Functions.showElement(this._addModalNameExists);
                            return;
                        }
                    }
                    // Request creation of new envelope
                    let request = { Name: this._addModalInput.value };
                    this._addModalOK.disabled = true;
                    this._core.Functions.showElement(this._addModalLoader);
                    this._core.Loader.genericServiceCallWithData("/User.svc/rest/CreateEnvelope", JSON.stringify(request), this._envelopeAdded, {}, this._errorCallback, this._failCallback);
                };
                this._enableDisableAddOK = (event) => {
                    this._log.info("ComponentEnvelopes._enableDisableAddOK()");
                    if (this._addModalInput.value != "")
                        this._addModalOK.disabled = false;
                    else
                        this._addModalOK.disabled = true;
                };
                this._addInputEnter = (event) => {
                    this._log.info("ComponentEnvelopes._addInputEnter()");
                    if (event.key === "Enter") {
                        if (this._addModalInput.value != "")
                            this._addOKClicked(null);
                    }
                };
                this._envelopeAdded = (response) => {
                    this._log.info("ComponentEnvelopes._envelopeAdded()");
                    this._core.Functions.hideElement(this._addModalLoader);
                    if (response.hasOwnProperty('Envelopes') && (response.Envelopes != null) && (response.Envelopes.length > 0)) {
                        this._newEnvelopeId = response.Envelopes[0].Id;
                        let modal = this._core.getModal(this._currentModalSession);
                        let comp = this;
                        modal.JQ.one('hidden.bs.modal', function () {
                            comp._envelopeAddedAfterHide();
                        });
                        this._core.hideModal(this._currentModalSession);
                    }
                    else
                        this._failCallback({ Connection: { Message: "AddEnvelopes returned success but no envelope data" } });
                };
                this._envelopeAddedAfterHide = () => {
                    this._log.info("ComponentEnvelopes._envelopeAddedAfterHide()");
                    if (this.EnvelopeAddedCallBack)
                        this.EnvelopeAddedCallBack(this._newEnvelopeId);
                    this.doSearch();
                };
                this.addDocToEnvelope = (docId, envId = null) => {
                    this._log.info("ComponentEnvelopes.addDocToEnvelope()");
                    if (!envId) {
                        if (this._currentEnvelope)
                            envId = this._currentEnvelope.Id;
                        else
                            return false;
                    }
                    this._core.Loader.genericServiceCall(`/User.svc/rest/AddDocumentToEnvelope/${envId}/${docId}`, this._docAddedToEnvelope.bind(this, envId), this._errorCallback, this._failCallback);
                    return true;
                };
                this._docAddedToEnvelope = (envId, response) => {
                    this._log.info("ComponentEnvelopes._docAddedToEnvelope()");
                    if (!this._selectOnlyMode)
                        this._docListReceived(envId, response);
                    if (this.DocumentAddedCallBack)
                        this.DocumentAddedCallBack(true);
                };
                this.removeDocFromEnvelope = (docId, envId = null) => {
                    this._log.info("ComponentEnvelopes.removeDocFromEnvelope()");
                    if (!envId) {
                        if (this._currentEnvelope)
                            envId = this._currentEnvelope.Id;
                        else
                            return false;
                    }
                    this._core.Loader.genericServiceCall(`/User.svc/rest/RemoveDocumentFromEnvelope/${envId}/${docId}`, this._documentRemoved.bind(this, envId), this._errorCallback, this._failCallback);
                    return true;
                };
                this._documentRemoved = (envId, response) => {
                    this._log.info("ComponentEnvelopes._documentRemoved()");
                    this.getEnvelopeContent(envId);
                };
                this.documentSelected = (handle) => {
                    this._log.info("ComponentEnvelopes.documentSelected()");
                    if (this._currentContentIds.indexOf(handle) > -1) {
                        this._currentDocId = handle;
                        if (this._showRemoveDoc)
                            this._core.Functions.showElement(this._removeDocButton);
                    }
                    else {
                        this._currentDocId = 0;
                        this._core.Functions.hideElement(this._removeDocButton);
                    }
                };
                this._deleteEnvelopeClicked = (event) => {
                    this._log.info("ComponentEnvelopes._deleteEnvelopeClicked()");
                    this._core.Helper.presentWarningContinueModal('STR_WPT_CONFIRM_DELETE_ENVELOPE', this._deleteEnvelopeConfirmed, 'STR_WPT_CONTINUE_HEADING');
                };
                this._deleteEnvelopeConfirmed = () => {
                    this._log.info("ComponentEnvelopes._deleteEnvelopeConfirmed()");
                    if (this._currentEnvelope)
                        this.deleteEnvelope(this._currentEnvelope.Id);
                };
                this._removeDocButtonClicked = (event) => {
                    this._log.info("ComponentEnvelopes._removeDocButtonClicked()");
                    this._core.Helper.presentWarningContinueModal('STR_WPT_CONFIRM_REMOVE_FROM_ENVELOPE', this._removeDocConfirmed, 'STR_WPT_CONTINUE_HEADING');
                };
                this._removeDocConfirmed = () => {
                    this._log.info("ComponentEnvelopes._removeDocConfirmed()");
                    if (this._currentEnvelope && this._currentDocId)
                        this.removeDocFromEnvelope(this._currentDocId, this._currentEnvelope.Id);
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("ComponentEnvelopes::constructor");
                this._config = config;
                // But the html is static
                if (!ComponentEnvelopes.Html || !ComponentEnvelopes.ModalHtml) {
                    if (!ComponentEnvelopes.Html) {
                        core.Loader.getVersionedHTML('widgets/components/envelopes.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
                    }
                    if (!ComponentEnvelopes.ModalHtml) {
                        core.Loader.getVersionedHTML('widgets/components/envelopes-modal.html', this._storeModalHtml, this._core.Helper.missingHtmlErrorCallback);
                    }
                }
                else {
                    this._readyToPresent = true;
                    if (this._waitingToPresent)
                        this._present();
                }
            }
            _present() {
                this._log.info("ComponentEnvelopes._present()");
                if (!this._readyToPresent) {
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("EnvelopesComponent._present() not ready - pausing");
                    }
                    this._waitingToPresent = true;
                    return;
                }
                this._container.innerHTML = ComponentEnvelopes.Html;
                this._loader = this._container.querySelector('.wpt-hourglass');
                this._noRecords = this._container.querySelector('#envelopesNoRecords');
                this._holder = this._container.querySelector('#envelopesHolder');
                this._deleteButton = this._container.querySelector('#envelopeComponentDeleteBtn');
                this._removeDocButton = this._container.querySelector('#envelopeComponentRemoveDocBtn');
                this._core.Helper.prepareHourglassIcon(this._loader);
                // Translations
                this._core.Helper.setElementTranslation(this._container.querySelector('#envelopesLoading'), 'STR_WPT_LOADING');
                this._core.Helper.setElementTranslation(this._container.querySelector('#envelopesNoRecordsLabel'), 'STR_WPT_NOINFO');
                this._core.Helper.setElementTranslation(this._deleteButton.querySelector('#envelopeComponentDeleteBtnLabel'), 'STR_WPT_DELETE_ENVELOPE');
                this._core.Helper.setElementTranslationAttribute(this._deleteButton, 'title', 'STR_WPT_DELETE_ENVELOPE');
                this._core.Helper.setElementTranslation(this._removeDocButton.querySelector('#envelopeComponentRemoveDocBtnLabel'), 'STR_WPT_REMOVE_FROM_ENVELOPE');
                this._core.Helper.setElementTranslationAttribute(this._removeDocButton, 'title', 'STR_WPT_REMOVE_FROM_ENVELOPE');
                // Events
                this._container.querySelector('#envelopesNoRecordsReload').addEventListener('click', this.doSearch);
                this._deleteButton.addEventListener('click', this._deleteEnvelopeClicked);
                this._removeDocButton.addEventListener('click', this._removeDocButtonClicked);
                let listConfig = {
                    SelectItemCallback: this._envelopeClicked
                };
                this._dataList = new Widgets.ComponentDataList(this._core, this._holder, null, listConfig);
                this._dataList.present();
                // Options
                let conf = this._config;
                if (conf.hasOwnProperty('SelectOnlyMode') && (conf.SelectOnlyMode != null))
                    this._selectOnlyMode = conf.SelectOnlyMode;
                if (conf.hasOwnProperty('SelectNewEnvelopes') && (conf.SelectNewEnvelopes != null))
                    this._selectNewEnvelopes = conf.SelectNewEnvelopes;
                if (conf.hasOwnProperty('ShowDelete') && (conf.ShowDelete != null))
                    this._showDelete = conf.ShowDelete;
                if (conf.hasOwnProperty('ShowRemoveDoc') && (conf.ShowRemoveDoc != null))
                    this._showRemoveDoc = conf.ShowRemoveDoc;
                // Go!
                this._componentReady = true;
                if (this._displayPending)
                    this.doSearch();
            }
        }
        ComponentEnvelopes.Html = null;
        ComponentEnvelopes.ModalHtml = null;
        Widgets.ComponentEnvelopes = ComponentEnvelopes;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
